
import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  Grid,
  Autocomplete,
} from "@mui/material";
import dayjs from "dayjs";
import { Calendar } from "../../../Componants/Common/Calender";
import CommonButton from "../../../Componants/Common/Button";



const SubscriptionModal = ({ open, handleClose }) => {
  

  return (
  <></>
  );
};

export default SubscriptionModal;
